var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"data":_vm.data,"onManager":_vm.onManager,"base-info":_vm.baseInfo,"nameRules":_vm.nameRules}})
}
var staticRenderFns = []

export { render, staticRenderFns }